import PropTypes from 'prop-types';

const netZeroPropTypes = {
  cars: PropTypes.arrayOf(
    PropTypes.shape({
      annualMileage: PropTypes.string,
      details: PropTypes.shape({
        co2Emissions: PropTypes.number,
        fuelType: PropTypes.oneOf(['ELECTRICITY', 'PETROL']),
      }),
      numberPlate: PropTypes.string,
    }),
  ),
  setCars: PropTypes.func,
  heatingMethod: PropTypes.string,
  setHeatingMethod: PropTypes.func,
  usage: PropTypes.shape({
    bedroomCount: PropTypes.string,
    electricityUsage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    heatingUsage: PropTypes.number,
  }),
  setUsage: PropTypes.func,
  carError: PropTypes.shape({
    error: PropTypes.string,
    numberPlate: PropTypes.string,
  }),
  setCarError: PropTypes.func,
};

export default netZeroPropTypes;
